"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var icon_1 = require("./icon");

var field = ui_blocks_1.FORM.field,
    hasErrors = ui_blocks_1.FORM.hasErrors;
var focusInverse = ui_blocks_1.INTERACTIVE.focusInverse;
var caption = ui_blocks_1.TYPOGRAPHY.caption; // Sizes =======================================================================

var Sizes;

(function (Sizes) {
  Sizes[Sizes["tiny"] = 4] = "tiny";
  Sizes[Sizes["small"] = 5] = "small";
  Sizes[Sizes["medium"] = 6] = "medium";
  Sizes[Sizes["large"] = 7] = "large";
})(Sizes || (Sizes = {}));

var SizePadding;

(function (SizePadding) {
  SizePadding[SizePadding["tiny"] = 2] = "tiny";
  SizePadding[SizePadding["small"] = 2] = "small";
  SizePadding[SizePadding["medium"] = 2.5] = "medium";
  SizePadding[SizePadding["large"] = 3] = "large";
})(SizePadding || (SizePadding = {}));

var makeSizeStyles = function makeSizeStyles(size, theme) {
  var _a, _b;

  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  padding: 0 ", ";\n"], ["\n  height: ", ";\n  padding: 0 ", ";\n"])), (0, ui_symbols_1.calcSpace)(Sizes[size], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP), (0, ui_symbols_1.calcSpace)(SizePadding[size], (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP));
};

var isLeadingIconStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding-left: ", ";\n"], ["\n  padding-left: ", ";\n"])), (0, ui_symbols_1.calcSpace)(5));
var isTrailingIconStyles = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  padding-right: ", ";\n"], ["\n  padding-right: ", ";\n"])), (0, ui_symbols_1.calcSpace)(5));
var hasErrorsStyles = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  & ~ ", " {\n    color: ", ";\n  }\n"], ["\n  ", "\n\n  & ~ ", " {\n    color: ", ";\n  }\n"])), hasErrors, icon_1.IconWrapper, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ERROR', theme);
});
var isInverseStyles = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  background: transparent;\n  color: ", ";\n\n  &:focus-within {\n    outline: none;\n    ", "\n  }\n"], ["\n  background: transparent;\n  color: ", ";\n\n  &:focus-within {\n    outline: none;\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, focusInverse);
var captionTypography = (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  ::placeholder {\n    ", "\n  }\n"], ["\n  ", "\n\n  ::placeholder {\n    ", "\n  }\n"])), caption, caption);
exports.Input = styled_components_1.default.input.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['sizeOption', 'hasErrors', 'isLeading', 'isTrailing', 'isInverse', 'multiLine'].includes(prop);
  }
})(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  ", "\n  width: 100%;\n\n  &:focus ~ ", " {\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  width: 100%;\n\n  &:focus ~ ", " {\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), field, icon_1.IconWrapper, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, function (props) {
  return props.as !== 'textarea' ? (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeSizeStyles) : (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n          resize: vertical;\n          overflow: auto;\n          min-height: ", ";\n          padding-bottom: ", ";\n          padding-top: ", ";\n          padding-left: ", ";\n          padding-right: ", ";\n        "], ["\n          resize: vertical;\n          overflow: auto;\n          min-height: ", ";\n          padding-bottom: ", ";\n          padding-top: ", ";\n          padding-left: ", ";\n          padding-right: ", ";\n        "])), function (_a) {
    var _b;

    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(7, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
  }, function (_a) {
    var _b;

    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(1.5, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
  }, function (_a) {
    var _b;

    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(1.5, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
  }, function (_a) {
    var _b;

    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(2.5, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
  }, function (_a) {
    var _b;

    var theme = _a.theme;
    return (0, ui_symbols_1.calcSpace)(2, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
  });
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasErrors', hasErrorsStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isLeading', isLeadingIconStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isTrailing', isTrailingIconStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', isInverseStyles);
}, function (_a) {
  var sizeOption = _a.sizeOption;
  return (sizeOption === 'tiny' || sizeOption === 'small') && captionTypography;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;